import { useState } from "react";
import DailyTransaction from "./components/DailyTransaction";
import RevenueTable from "./components/RevenueTable";

export default function Index() {
  const [activeTab, setActiveTab] = useState("daily");

  const tabs = [
    { id: "daily", label: "Daily", content: <DailyTransaction /> },
    { id: "revenue", label: "Transaction", content: <RevenueTable /> },
  ];

  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
      <div className="my-4">
        <ul className="flex flex-col sm:flex-row gap-2 sm:gap-0 text-sm font-medium">
          {tabs.map((tab) => (
            <li key={tab.id} className="sm:me-2">
              <button
                className={`w-full sm:w-auto inline-block font-semibold rounded-xl p-3 border transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "bg-blue-600 text-white border-blue-700"
                    : "bg-white text-gray-800 border-gray-200 hover:text-gray-900 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab(tab.id)}
                type="button"
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="tab-content">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`rounded-lg transition-opacity duration-300 ${
              activeTab === tab.id ? "block" : "hidden"
            }`}
          >
            <main className="text-sm text-gray-500">{tab.content}</main>
          </div>
        ))}
      </div>
    </div>
  );
}